<template>
  <el-row class="app-footer" :class="{'blueFooter': !isBlueFooter}" align="middle">
    <el-col :span="24"  justify="center" >
      <p>2021 &copy; Copyright Pixeon <el-divider direction="vertical"></el-divider> Todos direitos reservados</p>
    </el-col>
  </el-row>
</template>

<script>
import { useRoute } from 'vue-router'
import { computed } from 'vue'
export default {
  name: 'Footer',
  setup () {
    const route = useRoute()

    const isBlueFooter = computed(() => {
      return route.path === '/' || route.path === '/auth'
    })

    return {
      isBlueFooter
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-footer {
  position: fixed;
  bottom: 0;
  width: 100vw;
  @include gradientBackground;
  text-align: center;
  min-height: 6rem;
  font-weight: 300;
  color: $white;
  p {
    font-size: 1.2rem;
  }
}
.blueFooter {
  background: $blue;
}
</style>>
